import fetch from "auth/FetchInterceptor";

const InformationService = {};

InformationService.getInformation = function (informationId, languageId) {
  return fetch({
    url: `/information/${informationId}/`,
    method: "get",
    headers: {
      "Language-Id": languageId, // Pass the language ID in headers
      "Store-Id": localStorage.getItem("storeId"),
    },
  });
};

// update information

InformationService.updateInformation = function (params, languageId) {
  console.log("params", params);

  return fetch({
    url: `/update-description/${params.information_id}/`,
    method: "patch",
    data: params,
  });
};

InformationService.getAnalyticsData = function (languageId) {
  return fetch({
    url: `/analytics-stats/`,
    method: "get",
    headers: {
      "Language-Id": languageId,
    },
  });
};

// Add Meta Campaign Stats API
InformationService.getMetaCampaignStats = function (
  adAccountId,
  dateRange = 30
) {
  return fetch({
    url: `/meta-campaign-stats/?ad_account_id=${adAccountId}&date_range=${dateRange}`,
    method: "get",
  });
};

export default InformationService;
